module.exports = __webpack_public_path__ + "static/media/Lahore-High-Court.fd8a6923.jpg";